<template>
  <BaseLayout>
    <div class="">
      <div class="text-center">
        <img class="w-45" src="../assets/bg/contact.svg" />
        <div class="w-75 mx-auto mt-5">
          <h1 class="mb-3">{{ site.meta.contact_us.hero_section_title }}</h1>
          <h5 class="leading-loose">{{ site.meta.contact_us.hero_section_description }}</h5>
        </div>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseLayout from '@/layouts/BaseLayout.vue';

export default {
  name: 'ContactUs',
  components: {
    BaseLayout,
  },
  computed: {
    ...mapGetters({
      site: 'site/site'
    })
  },

  mounted() {
    this.setPageMeta(this.site.meta.contact_us);
  },

  methods: {
    setPageMeta(meta = {}) {
      const { page_title, page_description, robots_index } = meta;
      if (page_title) document.title = page_title || 'Studio Metrodesk';
      const descEl = document.querySelector('meta[name="description"]');
      if (descEl) descEl.setAttribute('content', page_description || '');
      const robotsEl = document.querySelector('meta[name="robots"]');
      if (robotsEl) robotsEl.setAttribute('content', robots_index === 'noindex' ? 'noindex, nofollow' : 'index, follow');
    },
  },
};
</script>

<style scoped>
.w-45 {
  width: 45% !important;
}
.w-50 {
  width: 50% !important;
}
.w-75 {
  width: 75% !important;
}
.leading-loose {
  line-height: 2;
}
</style>
